<script>
import Layout from "../../../router/layouts/print";
/* eslint-disable no-console */
/**
 * Invoice-detail component
 */
export default {
  components: { Layout },
  data() {
    return {
      contract: null,
      // saleDates: [],
      // registerDates: [],

      //partners: []
    };
  },
  mounted() {},

  watch: {
    data: function(newVal) { 
      this.contract = newVal;
      console.log(this.contract);
    }
  },

  methods: {

    formatCurrency(value, sign = '', decimal = '.00') {
      return  sign.length > 1 ? sign + this.$options.filters.numFormat(value, `0,0${decimal}`) : this.$options.filters.numFormat(value, `${sign}0,0${decimal}`);
    }

  },

  props: {
    data: null,
  }

};
</script>
<template>
  <Layout>
        <center>
          <div class="col dblack box-a4-long kh">
            <table width="100%">
              <tr>
                <td style="width:30%;"></td>
                <td style="width:40%;" rowspan="2" class="text-align-center">
                  <p class="khm title l3" style="margin-top: 0.2cm;">ព្រះរាជាណាចក្រកម្ពុជា</p>
                  <p class="khm h5 l4">ជាតិ សាសនា ព្រះមហាក្សត្រ</p>
                  <p class="top-0">
                    <img src="../../../assets/images/3symbol.svg" style="width: 150px;"/>
                  </p>
                </td>
                <td style="width:30%;"></td>
              </tr>
              <tr>
                <td rowspan="2">
                  <img src="@/assets/images/h-logo.svg" alt height="60" />
                </td>
                <td></td>
              </tr>
              <tr>
                <td></td>
                <td rowspan="2" class="text-align-right">
                  <p class="h6">ធ្វើនៅភ្នំពេញ, ថ្ងៃទី ២៦ ខែមករា ឆ្នាំ២០២២</p>
                  <p class="h6 top-0">លេខៈ <span class="enb">C112-260122</span></p>
                </td>
              </tr>
              <tr>
                <td></td>
                <td></td>
              </tr>
            </table>
           
            <p class="khm sub-title top3">សេចក្តីជូនដំណឹង ស្តីពី</p>
            <p class="khm sub-title top1">ការរំលាយកិច្ចព្រមព្រៀងលក់-ទិញលំនៅឋាន</p>
            <p class="en sub-title h1" style="margin-top: -15px">~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~</p>
  
            <table width="100%" class="doc-content top text-justify">
              <tr>
                <td width="15%"><p>&nbsp;</p></td>
                <td width="85%"><p>&nbsp;</p></td>
              </tr>
              <tr>
                <td>
                  <p class="khm">យោង</p>
                </td>
                <td>
                  <p style="text-align: justify;">
                    -កិច្ចព្រមព្រៀងលក់-ទិញលំនៅឋានលេខៈ {{contract && contract.contract_number}} ចុះថ្ងៃទី {{contract && contract.sale_date_show}}, រវាងក្រុមហ៊ុន
                    <span class="khm"> លំនៅឋាន អេចស៊ី ឯ.ក</span> តំណាងដោយលោកៈ <span class="khm">លឹម ទ្រី</span> (ភាគី “ក”) កាន់អត្តសញ្ញាណប័ណ្ណសញ្ជាតិខ្មែរលេខៈ 011335234 ចុះថ្ងៃទី 24-01-2019 ការិយាល័យកណ្តាលដីឡូតិ៍លេខៈ 742 ផ្លូវលេខៈ 1952 ភូមិបាយ៉ាប សង្កាត់ភ្នំពេញថ្មី ខណ្ឌសែនសុខ រាជធានីភ្នំពេញ។
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <p class="khm">ជាមួយនិង</p>
                </td>
                <td>
                  <p style="text-align: justify;">
                    -ឈ្មោះ <span class="khm">{{contract && contract.name}}</span> ភេទៈ {{contract && contract.sex}} ជនជាតិៈ {{contract && contract.nationality}} សញ្ជាតិៈ {{contract && contract.nationality}}
                  កាន់អត្តសញ្ញាណប័ណ្ណ / លិខិតឆ្លងដែនលេខៈ {{contract && contract.id_no}} ចុះថ្ងៃទីៈ {{contract && contract.id_date_show}}(ភាគី “ខ”)៕
                  </p>
                  <p style="text-align: justify;">-សេចក្តីជូនដំណឹង ស្តីពីការយឺតយ៉ាវបង់ប្រាក់ លើកទី១ លេខៈ C1-12-260122 ចុះថ្ងៃទី 26 ខែ មករា ឆ្នាំ 2022</p>
                  <p style="text-align: justify;">-សេចក្តីជូនដំណឹង ស្តីពីការយឺតយ៉ាវបង់ប្រាក់ លើកទី២ លេខៈ C1-12-260122 ចុះថ្ងៃទី 26 ខែ មករា ឆ្នាំ 2022</p>
                  <p style="text-align: justify;">-សេចក្តីជូនដំណឹង ស្តីពីការយឺតយ៉ាវបង់ប្រាក់ លើកទី១ លេខៈ C1-12-260122 ចុះថ្ងៃទី 26 ខែ មករា ឆ្នាំ 2022</p>
                </td>
              </tr>
            </table>
            <p><br/></p>
            <table class="doc-content top text-justify">
              <tr>
                <td width="70%"></td>
                <td width="30%"></td>
              </tr>
              <tr>
                <td colspan="2">
                  <p style="text-indent: 5em;">
                    <b>ដោយហេតុថា៖</b> ភាគី "ខ" បានរំលោភបំពានយ៉ាងធ្ងន់ធ្ងរលើកិច្ចព្រមព្រៀងលក់-ទិញលំនៅឋានដូចមានយោងមកខាងលើ ធ្វើ៉ឱ្យ ក្រុមហ៊ុនមានការខាតបង់យ៉ាងច្រើន
                    ដូចច្នេះក្រុមហ៊ុនសម្រេចរំលាយកិច្ចព្រមព្រៀងលក់-ទិញលំនៅឋាននេះចោលដោយឯកតោភាគីចាប់ពីថ្ងៃនេះតទៅ និងបើកលក់យូនីតខុនដូឡើងវិញ។ ដោយមិនចាំបាច់ជូនដំណឹងទៅភាគី "ខ" ម្តងទៀតឡើយ។
                  </p>
                </td>
              </tr>
              <tr>
                <td colspan="2"><p><br/></p></td>
              </tr>
              <tr>
                <td></td>
                <td>
                    <p class="khm" style="text-align: center;">ប្រធានគ្រប់គ្រង</p>
                    <br>
                    <br>
                    <br>
                    <br>
                    <br>
                    <p class="khm" style="text-align: center;"></p>
                </td>
              </tr>
            </table>
          </div>
        </center>
  </Layout>
</template>